// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"35ac9a76","312":"4b060718","364":"14145198","780":"dc838daf","861":"081c38bd"}[chunkId] + ".chunk.js";
};